import apiClient from "./apiClient";

export const fetchClickAnalyticsWithParams = async (params) => {
  const response = await apiClient.get("/conditions/analytics", {
    params: { ...params },
  });

  return response.data;
};

export const fetchUserClickAnalyticsWithParams = async (params) => {
  const response = await fetchClickAnalyticsWithParams(params);

  return response;
};

export const fetchUserKnowledgeCompetencies = async (params) => {
  const response = await apiClient.get("/users/cases", {
    params: { ...params },
  });

  return response.data;
};

export const fetchUserActivityLog = async (params) => {
  // New grouped quizzes endpoint
  const response = await apiClient.get("/users/quizzes", {
    params: { ...params },
  });

  return response.data;
};
